import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {addPatientToStaticList} from '../../user-property/UserPropertyEndPoint'
import {
    deleteStaticList,
    getListStaticList,
    getPageStaticList,
    getStaticListByHospitals,
} from '../StaticListEndPoint'

export const useStaticListByHospitals = (requestorId, hospitalIds = []) => {
    const {staticListKeys} = QueryKeyManager(
        QueryKeyTypes.staticList,
        requestorId,
    )
    return useQuery({
        queryKey: staticListKeys.userList({
            type: 'notificationSetting',
            hospitalIds: hospitalIds,
        }),
        queryFn: () => getStaticListByHospitals(requestorId, hospitalIds),
        enabled: !!requestorId && !!hospitalIds && hospitalIds.length > 0,
    })
}

export const usePageStaticList = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {staticListKeys} = QueryKeyManager(
        QueryKeyTypes.staticList,
        requestorId,
    )

    return useQuery({
        queryKey: staticListKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageStaticList(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useListStaticList = (
    requestorId,
    simple,
    filterRequest,
    enabled = true,
) => {
    const {staticListKeys} = QueryKeyManager(
        QueryKeyTypes.staticList,
        requestorId,
    )
    return useQuery({
        queryKey: staticListKeys.list({simple, filterRequest}),
        queryFn: () => getListStaticList(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const useStaticListAssignment = (requestorId, hospitalId) => {
    return useMutation({
        mutationFn: data =>
            addPatientToStaticList(requestorId, hospitalId, data),
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                showNotification(
                    severityNotification.success,
                    'Patients assigned to static list successfully !!',
                )
            }
        },
    })
}

export const useStaticListCRUD = (type, requestorId) => {
    const {staticListKeys} = QueryKeyManager(
        QueryKeyTypes.staticList,
        requestorId,
    )
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.delete
                ? deleteStaticList(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Static List Update Successfully !',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}
